// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import pin01Icon from "@/assets/icons/pin-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Pin01IconProps = Omit<IconProps, "name">;

export function Pin01Icon(props: Pin01IconProps): React.ReactNode {
  return <Icon name={pin01Icon} {...props} />;
}
